import * as _ from 'lodash';

import { IFormAnswer } from "../classes/index";

export function updateArray<T = any>(array: Array<T>, atIdx: number, withData: IFormAnswer) {
    return array.map((object, currIdx) => {
        if (currIdx !== atIdx) {
            return object;
        }

        // If the indices match, update the parent.
        const copiedObject = _.assign({}, object);
        copiedObject[withData.id] = withData.value;

        return copiedObject;
    });
}


export function updateMultipleArrayField<T = any>(array: Array<T>, atIdx: number, withData: Array<IFormAnswer>) {
    return array.map((object, currIdx) => {
        if (currIdx !== atIdx) {
            return object;
        }

        // If the indices match, update the parent.
        const copiedObject = _.assign({}, object);
        withData.map(data => {
            copiedObject[data.id] = data.value;
        })
        return copiedObject;
    });
}


// WEBPACK FOOTER //
// ./app/helpers/array-helpers.ts